import { Card, CardContent } from "@/components/ui/card";

const Testimonials = () => {
  const testimonials = [
    {
      initials: "SC",
      name: "Sarah Chen",
      title: "Startup Founder at TechFlow",
      quote: "The difference is night and day. Having actual Joylo developers work alongside me instead of being handed off to freelancers gave me confidence that my project was in expert hands.",
      gradient: "from-sunset-coral-400 to-soft-lavender-500"
    },
    {
      initials: "MR",
      name: "Marcus Rodriguez",
      title: "CTO at DataSync Pro",
      quote: "When we hit scaling challenges, the Joylo architect didn't just give advice - they rolled up their sleeves and helped us implement the solution. True partnership.",
      gradient: "from-soft-lavender-500 to-sunset-coral-400"
    },
    {
      initials: "EW",
      name: "Emily Watson",
      title: "Product Manager at InnovateLabs",
      quote: "The instant access to expert developers is game-changing. No more waiting days for support tickets. Click a button, get immediate help from someone who actually knows what they're doing.",
      gradient: "from-sunset-coral-400 to-soft-lavender-500"
    }
  ];

  return (
    <section className="py-10 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="text-left sm:text-center mb-8 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-ink-blue-900 mb-3 sm:mb-4 leading-[1.15]">
            Trusted by Developers Worldwide
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-soft-gray-600 leading-relaxed">
            See what our clients say about working with dedicated Joylo architects
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="bg-white border border-warm-cream-200 shadow-elegant hover:shadow-elegant-xl transition-shadow duration-300">
              <CardContent className="p-6 sm:p-8">
                <div className="mb-5 sm:mb-6">
                  <div className="flex text-soft-lavender-500 mb-3 sm:mb-4">
                    {[...Array(5)].map((_, i) => (
                      <svg key={i} className="w-4 h-4 sm:w-5 sm:h-5 fill-current" viewBox="0 0 20 20">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                  </div>
                  <p className="text-sm sm:text-base text-soft-gray-700 leading-relaxed italic">
                    "{testimonial.quote}"
                  </p>
                </div>
                <div className="flex items-center">
                  <div className={`w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-r ${testimonial.gradient} text-white rounded-full flex items-center justify-center text-xs sm:text-sm font-semibold mr-3 sm:mr-4 flex-shrink-0`}>
                    {testimonial.initials}
                  </div>
                  <div className="min-w-0">
                    <h4 className="font-semibold text-ink-blue-900 text-sm sm:text-base truncate">{testimonial.name}</h4>
                    <p className="text-soft-gray-600 text-xs sm:text-sm truncate">{testimonial.title}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;